import Vue from "vue";
import VueRouter from "vue-router";
// import home from "../views/index.vue";
// import index from "../views/indexDialog.vue";
// import modelPage from "../views/model/index.vue";
// import aiotModelPage from "../views/aiotModel/index.vue";
// import aiotDialog from "../views/aiotDialog/index.vue";
// import SSOLogin from "../views/login/SSOLogin.vue";
// import notFound from "../components/notFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "home",
    component: () => import("@/views/index.vue"),
  },
  {
    path: "/SSOLogin",
    name: "SSOLogin",
    component: () => import("@/views/login/SSOLogin.vue"),
  },
  {
    path: "/HRSSCService",
    // path:'/special/:type',
    name: "index",
    component: () => import("@/views/indexDialog.vue"),
  },
  {
    path: "/modelService",
    name: "modelPage",
    component: () => import("@/views/model/index.vue"),
  },
  {
    path: "/modelService/:type",
    name: "modelPage",
    component: () => import("@/views/model/index.vue"),
  },
  {
    path: "/aiotModelService",
    name: "aiotModelPage",
    component: () => import("@/views/aiotModel/index.vue"),
  },
  {
    path: "/aiotDialog",
    name: "aiotDialog",
    component: () => import("@/views/aiotDialog/index.vue"),
  },
  // {
  //   path:'/404',
  //   name:'404notFound',
  //   component:notFound,
  // },
];

const router = new VueRouter({
  mode: "history",
  base: "/chat",
  routes,
});

export default router;
